import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4715f65d")

_pushScopeId("data-v-4715f65d")
const _hoisted_1 = { class: "btn_area_wrap" }
const _hoisted_2 = { class: "btn_area" }
const _hoisted_3 = {
  key: 1,
  class: "btn is_inactive"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.product.isPurchasable)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("button", {
              class: ["btn", _ctx.classForPurchaseButton],
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveToPurchasePage && _ctx.moveToPurchasePage(...args)))
            }, "구매하기", 2),
            (_ctx.product.isGiftable)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn btn_full",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveToPresentPage && _ctx.moveToPresentPage(...args)))
                }, "선물하기"))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock("button", _hoisted_3, "판매 중지된 상품입니다."))
    ])
  ]))
})